/**
 * Hairmosa — "She is the moment" (accueil).
 * Point cliquable -> panneau attaché sous la photo (un seul ouvert à la fois).
 * Curseur cliquable, contextuel au look le plus proche du centre du rail au défilement.
 * Aucune librairie, aucune dépendance à un autre script du thème.
 */
(function () {
  if (!window.customElements || window.customElements.get('hm-shop-the-look')) {
    return;
  }

  function closestLookIndex(rail, looks) {
    var axis = rail.getBoundingClientRect().left + 40;
    var closest = 0;
    var distance = Infinity;

    looks.forEach(function (look, index) {
      var d = Math.abs(look.getBoundingClientRect().left - axis);
      if (d < distance) {
        distance = d;
        closest = index;
      }
    });

    return closest;
  }

  class HmShopTheLook extends HTMLElement {
    connectedCallback() {
      this._rail = this.querySelector('.hm-look-rail');
      this._looks = [].slice.call(this.querySelectorAll('.hm-look'));
      this._dots = [].slice.call(this.querySelectorAll('.hm-curseur button'));
      this._button = this.querySelector('.hm-look__bouton');
      this._flechePrec = this.querySelector('[data-hm-look-fleche="prec"]');
      this._flecheSuiv = this.querySelector('[data-hm-look-fleche="suiv"]');
      this._current = -1;

      this._onPointClick = this._onPointClick.bind(this);
      this._onFermerClick = this._onFermerClick.bind(this);
      this._onScroll = this._onScroll.bind(this);

      this.querySelectorAll('.hm-look__point').forEach(function (point) {
        point.addEventListener('click', this._onPointClick);
      }, this);

      this.querySelectorAll('.hm-look__fermer').forEach(function (button) {
        button.addEventListener('click', this._onFermerClick);
      }, this);

      this._dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          this._allerA(index);
        }.bind(this));
      }, this);

      /* Flèches précédent/suivant : uniquement à partir de la largeur (voir media query dans
         hm-sections.css) où le glissement au doigt n'est plus l'interaction naturelle. Même
         défilement doux que le clic sur une puce du curseur : c'est la même détection de look
         (_followScroll, via l'évènement scroll du rail) qui referme le panneau ouvert et met à
         jour le curseur et le bouton contextuel. */
      if (this._flechePrec) {
        this._flechePrec.addEventListener('click', function () { this._allerA(this._current - 1); }.bind(this));
      }
      if (this._flecheSuiv) {
        this._flecheSuiv.addEventListener('click', function () { this._allerA(this._current + 1); }.bind(this));
      }

      if (this._rail && this._looks.length) {
        this._rail.addEventListener('scroll', this._onScroll, { passive: true });
        this._followScroll();
      }
    }

    _allerA(index) {
      var look = this._looks[index];
      if (this._rail && look) {
        this._rail.scrollTo({ left: look.offsetLeft - this._rail.offsetLeft, behavior: 'smooth' });
      }
    }

    disconnectedCallback() {
      if (this._rail) {
        this._rail.removeEventListener('scroll', this._onScroll);
      }
    }

    _onPointClick(event) {
      var point = event.currentTarget;
      var panel = document.getElementById(point.getAttribute('aria-controls'));
      if (!panel) {
        return;
      }

      var wasHidden = panel.hasAttribute('hidden');
      this._fermerPanneauOuvert();

      if (wasHidden) {
        panel.hidden = false;
        point.setAttribute('aria-expanded', 'true');
      }
    }

    _onFermerClick() {
      this._fermerPanneauOuvert();
    }

    _fermerPanneauOuvert() {
      this.querySelectorAll('.hm-look__panneau').forEach(function (p) {
        p.hidden = true;
      });
      this.querySelectorAll('.hm-look__point').forEach(function (p) {
        p.setAttribute('aria-expanded', 'false');
      });
    }

    _followScroll() {
      var index = closestLookIndex(this._rail, this._looks);
      if (index === this._current) {
        return;
      }
      this._current = index;

      /* Le look affiché a changé (glissement au doigt ou clic sur une puce du curseur, qui
         défile aussi le rail) : referme immédiatement tout panneau resté ouvert sur un autre
         look, sans attendre la fin de l'inertie, pour éviter qu'il ne se retrouve sous une
         photo qui n'est pas la sienne et laisse un vide sous la photo affichée. */
      this._fermerPanneauOuvert();

      this._dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      /* Jamais masquées (juste désactivées) : les faire disparaître décalerait la photo. */
      if (this._flechePrec) {
        this._flechePrec.disabled = index === 0;
      }
      if (this._flecheSuiv) {
        this._flecheSuiv.disabled = index === this._looks.length - 1;
      }

      var look = this._looks[index];
      var button = this._button;
      if (button && look) {
        button.style.opacity = 0;
        setTimeout(function () {
          button.textContent = look.getAttribute('data-bouton');
          button.setAttribute('href', look.getAttribute('data-lien'));
          button.style.opacity = 1;
        }, 140);
      }
    }

    _onScroll() {
      this._followScroll();
    }
  }

  window.customElements.define('hm-shop-the-look', HmShopTheLook);
})();
